var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
function getFilterKey(params) {
    return params.property + ":" + (params.groupId || '');
}
var FilterQuery = /** @class */ (function () {
    function FilterQuery(initialValue) {
        var _this = this;
        this.value = {};
        initialValue.forEach(function (filter) {
            _this.value[getFilterKey(filter)] = Object.freeze(filter);
        });
    }
    FilterQuery.fromArray = function (filters) {
        return new this(filters);
    };
    FilterQuery.fromGroups = function (filterGroups) {
        var items = Object.keys(filterGroups).reduce(function (acc, groupId) {
            var filters = filterGroups[groupId];
            return __spreadArrays(acc, filters.map(function (filter) { return (__assign(__assign({}, filter), { groupId: groupId })); }));
        }, []);
        return new this(items);
    };
    FilterQuery.prototype.fromArray = function (filters) {
        return new this.constructor(filters);
    };
    FilterQuery.prototype.mapFilter = function (filterIndex, map) {
        var index = typeof filterIndex === 'string' ? { property: filterIndex, groupId: '' } : filterIndex;
        var nextValue = [];
        if (!this.value[getFilterKey(index)]) {
            nextValue = Array.from(Object.values(this.value));
            var nextFilterValue = typeof map === 'function' ? map({ property: index.property, value: '' }) : map;
            if (nextFilterValue !== null) {
                nextValue.push(__assign(__assign(__assign({}, nextFilterValue), { property: index.property }), (index.groupId ? { groupId: index.groupId } : {})));
            }
            return new this.constructor(nextValue);
        }
        Object.values(this.value).forEach(function (value) {
            var matchGroup = (value.groupId || '') === index.groupId;
            if (value.property === index.property && matchGroup) {
                var nextFilterValue = typeof map === 'function' ? map(value) : map;
                if (nextFilterValue !== null) {
                    nextValue.push(__assign(__assign(__assign({}, nextFilterValue), { property: index.property }), (index.groupId ? { groupId: index.groupId } : {})));
                }
                return;
            }
            nextValue.push(value);
        });
        return new this.constructor(nextValue);
    };
    FilterQuery.prototype.getFilterValue = function (filterIndex) {
        var _a;
        return ((_a = this.getFilter(filterIndex)) === null || _a === void 0 ? void 0 : _a.value) || null;
    };
    FilterQuery.prototype.getFilter = function (filterIndex) {
        var index = typeof filterIndex === 'string' ? { property: filterIndex, groupId: '' } : filterIndex;
        return this.value[getFilterKey(index)] || null;
    };
    FilterQuery.prototype.getFilterList = function () {
        return Object.values(this.value);
    };
    FilterQuery.prototype.getFilterLisByGroupId = function (groupId) {
        return Object.values(this.value).filter(function (v) { return v.groupId === groupId; });
    };
    FilterQuery.prototype.toString = function () {
        return JSON.stringify(this.getFilterList());
    };
    return FilterQuery;
}());
export { FilterQuery };
//# sourceMappingURL=FilterQuery.js.map